import { Button, ListItemIcon, ListItemText, Menu, MenuItem } from "@mui/material";
import ShareIcon from '@mui/icons-material/Share';
import { useState } from "react";
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import EmailIcon from '@mui/icons-material/Email';
import SmsIcon from '@mui/icons-material/Sms';
import DialogConfiguracaoWhatsapp from "./DialogConfiguracaoWhatsapp";
import DialogConfiguracaoEmail from "./DialogConfiguracaoEmail";

export default function BtnCompartilhar({
    mensagem,
    meio = ['whatsapp'],
    recibo,
    tipo_publico,
    codigo_publico,
}: BtnCompartilharProps) {

    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const [openWhatsApp, setOpenWhatsApp] = useState(false)
    const [openEmail, setOpenEmail] = useState(false)
    const open = Boolean(anchorEl);

    const handleClick = async (event: React.MouseEvent<HTMLButtonElement>) => setAnchorEl(event.currentTarget)

    const handleClose = () => setAnchorEl(null);

    const handleWhatsApp = () => {
        setOpenWhatsApp(true)
    }

    const handleEmail = () => {
        setOpenEmail(true)
    }

    return (
        <>
            <Button
                startIcon={<ShareIcon />}
                onClick={handleClick}
                variant="outlined"
                aria-controls={open ? 'basic-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
            >
                Compartilhar
            </Button>
            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                slotProps={{
                    list: {
                        'aria-labelledby': 'basic-button'
                    }
                }}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
            >
                <MenuItem onClick={handleWhatsApp} disabled={!meio.includes('whatsapp')}>
                    <ListItemIcon>
                        <WhatsAppIcon color="success" fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Whatsapp</ListItemText>
                </MenuItem>

                <MenuItem onClick={handleClose} disabled={!meio.includes('sms')}>
                    <ListItemIcon>
                        <SmsIcon color="warning" fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>SMS</ListItemText>
                </MenuItem>

                <MenuItem onClick={handleEmail} disabled={!meio.includes('email')}>
                    <ListItemIcon>
                        <EmailIcon color="info" fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Email</ListItemText>
                </MenuItem>
            </Menu>
            {
                openWhatsApp &&
                <DialogConfiguracaoWhatsapp
                open={openWhatsApp}
                {...{mensagem, tipo_publico, codigo_publico}}
                onClose={() => setOpenWhatsApp(false)}
                />
            }
            {
                openEmail &&
                <DialogConfiguracaoEmail
                open={openEmail}
                {...{recibo}}
                onClose={() => setOpenEmail(false)}
                />
            }
        </>
    )
}

interface BtnCompartilharProps {
mensagem?: string;
meio?: ('whatsapp' | 'email' | 'sms')[];
recibo?: number;
tipo_publico?: string;
codigo_publico?: string;
}
